import { clsx } from 'clsx';
import { createComponent } from 'helpers/react';

export const SectionHeader = createComponent(
  'h2',
  'text-scale-neutral-700 bg-scale-neutral-50 inline-block rounded-[20px] font-bold text-base px-3 py-2 sm:text-2xl sm:px-5 sm:py-3'
);

export const SectionContent = createComponent('div', 'mt-8 sm:mt-12');

export const SectionDetail = createComponent(
  'div',
  'py-2.5 px-5 text-scale-dark-blue rounded-xl shadow-scale-sm sm:py-8 sm:px-16'
);

export const SectionActions = createComponent(
  'div',
  'flex flex-col-reverse space-y-4 space-y-reverse sm:px-14 sm:py-5 md:flex-row md:items-center md:justify-between md:space-y-0 xl:px-14 xl:py-0'
);

export const ActionWrapper = createComponent('div', 'min-w-auto md:w-[215px]');

export const ErrorMessage = createComponent(
  'p',
  'text-sm text-scale-red pt-2 h-6'
);

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  error?: boolean;
}

export function Section({ error, children, className }: SectionProps) {
  const classes = clsx(
    'py-6 px-4 bg-ds-white sm:p-6 xl:p-12',
    // error state
    error && 'border border-scale-red',
    // additional classes
    className
  );

  return <section className={classes}>{children}</section>;
}

interface SectionWithBorderProps {
  children: React.ReactNode;
  className?: string;
  error?: boolean;
}

export function SectionWithBorder({
  error,
  children,
  className
}: SectionWithBorderProps) {
  const classes = clsx(
    'relative rounded-[7px] bg-scale-neutral-50 px-4 py-2 md:rounded-[9px] md:px-12 md:py-3',
    // error state
    error && 'border-t border-b border-r border-scale-red',
    // before pseudo-element for the left border
    "before:content-[''] before:absolute before:top-0 before:left-0 before:bottom-0 before:border-solid before:border-[3px] md:before:border-[4px] before:border-l-[3px] before:border-t-[3px] before:border-r-0 before:border-b-[3px] before:rounded-tl-[12px] before:rounded-bl-[12px]",
    // conditional border color based on error state
    error ? 'before:border-scale-red' : 'before:border-scale-blue',
    // additional classes
    className
  );

  return <div className={classes}>{children}</div>;
}
